import React from 'react'

export const Contact = () => {
  return (
    <div className='contact'>
      <main>

        <h1>Contact Us</h1>

        <form>
          <div>
            <label>Name</label>
            <input type="text" placeholder='Full Name' required/>
          </div>
          <div>
            <label>Email</label>
            <input type="text" placeholder='abc@mail.com' required/>
          </div>
          <div>
            <label>Message</label>
            <input type="text" placeholder='Type your query here...' required/>
          </div>

          <button type='submit'>Send</button>
        </form>
        
      </main>
    </div>
  )
}
